import { render } from "./designfoodslide3.vue?vue&type=template&id=452a342e&scoped=true"
import script from "./designfoodslide3.vue?vue&type=script&lang=js"
export * from "./designfoodslide3.vue?vue&type=script&lang=js"

import "./designfoodslide3.vue?vue&type=style&index=0&id=452a342e&lang=less&scoped=true"

import exportComponent from "/Users/zhoubenhao/Desktop/行云/numatch/numatch-home/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-452a342e"]])

export default __exports__